module.exports = __webpack_public_path__ + "img/vcontroller-show-ac-control.ec1fb242.png";